import { Component, OnInit, ViewContainerRef, HostListener, Inject } from '@angular/core';
import { trigger, transition, animate, style } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../../../../app.service';
import { DigitalFormService } from '../../digital-form.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SectionQuestionsVM, DigitalFormVM, DigitalFormQuestionsCategoriesVM, DigitalFormQuestionsVM, DigitalFormQuestionTypesVM, UpdateQuestion, ObservationPointVM, ObPointMeasurementVM, FormHeaderVM, FlagTypesVM, ComponentsVM } from '../../../favourite-dialog/favourite-dialog-modal';
import { EditPhotoDigitalComponent } from '../edit-photo-digital/edit-photo-digital.component';
import { FileReaderEvent } from '../../../setup-implement/setup-implement.component';
import { ClearFlagDialogComponent } from '../clear-flag-dialog/clear-flag-dialog.component';
import { FlagCommentComponent } from '../flag-comment/flag-comment.component';
import { UserService } from '../../../../../../app/shared/services/user.service';
import { NotificationsService } from 'angular2-notifications';
import { AddCrackObsPointDialogComponent } from '../../../add-crack-obs-point-dialog/add-crack-obs-point-dialog.component';
import { CrackStausUpdateVM } from '../../../entities/component/model';
import { GETInventoryService } from '../../../services/inventory.service';
import { PreferencesService } from '../../../../../modules/preferences/preferences.service';
import { CryptoService } from '../../../../../services/crypto.service';
import { heicTo } from 'heic-to';

@Component({
  selector: 'app-digital-form-section-questions',
  templateUrl: './digital-form-section-questions.component.html',
  styleUrls: ['./digital-form-section-questions.component.scss'],
  animations: [
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(25%)', opacity: 0 }),
        animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('500ms', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ]
    )]
})
export class DigitalFormSectionQuestionsComponent implements OnInit {
  formId: number;
  uploadId: number;
  sectionId: number;
  selectedQId: number;
  DigtalFormOverview: SectionQuestionsVM;
  NotFixedCracks: boolean = true;
  FixedCracks: boolean = true;
  diabledFlag: boolean = true;
  showPrevBtn: boolean = false;
  //showNextBtn: boolean = false;
  showNextBtn: boolean = false;
  form: DigitalFormVM;
  formQSections: DigitalFormQuestionsCategoriesVM[];
  formQuestions: DigitalFormQuestionsVM[];
  questionTypes: DigitalFormQuestionTypesVM[];
  schematicImage: string;
  obsDetails: ObservationPointVM[];
  CopyobsDetails: ObservationPointVM[];
  fq: DigitalFormQuestionsVM;
  flagTypes: FlagTypesVM[];
  isSupervisour: boolean = false;
  UpdateExsitingAnswer: boolean = false;
  InspectionSMU: number;
  crackStatus: number;
  eventDate: Date = new Date();
  PrefUOM: number
  selectedUOM: number
  measurementinInches: number;
  measurementinMM: number;
  answerAdded: boolean = false;
  fqOld: DigitalFormQuestionsVM;
  isAnswerMandatory: boolean = false;
  UOMLabel: string = "mm";
  obsFlagClearComment: string;
  Loading: boolean = true;
  QuestionList: DigitalFormQuestionsVM[] = [];
  loadingobs: boolean = false;
  validation: boolean = true;
  selectedObservationPoint: ObservationPointVM;
  observationpointMeasurements: ObPointMeasurementVM[];
  questionObservationInfo: ObPointMeasurementVM[];
  obsComment: string;
  currentIndex: number;
  showobprev: boolean = true;
  showobnext: boolean = true;
  obsUnable: boolean = false;
  obsWIP: boolean = false;
  headerFormList: FormHeaderVM[];
  componentList: ComponentsVM[];
  schematicImageId: number;
	parentCatName: string;
  qCategoryName: string;
  constructor(private _route: ActivatedRoute, private _router: Router,
    public toastr: NotificationsService, vcr: ViewContainerRef, public _inventoryService: GETInventoryService,
    public _formService: DigitalFormService, private _editPhotoDialog: MatDialog, private _user: UserService,
    private _appService: AppService, private _sanitizer: DomSanitizer,
    private readonly _pref: PreferencesService,
    private _crypto: CryptoService , public dialogRef: MatDialogRef<DigitalFormSectionQuestionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, ) { }

  @HostListener('window:beforeunload', ['$event'])
  public beforeunloadHandler($event) {
    console.log("$event", $event)
    $event.returnValue = true;
  }
  ngOnInit() {
    this._appService.setPageTitle('Digital Inspection- Summary');
    this.LoadJobRoles();
    this.getUnitOFMeasurement();
    //this._appService.setPageSubTitle('');
    // this.formId = +this._route.snapshot.paramMap.get('formId');
    // this.uploadId = +this._route.snapshot.paramMap.get('uploadId');
    // this.sectionId = +this._route.snapshot.paramMap.get('catId');
    // this.selectedQId = +this._route.snapshot.paramMap.get('qId');
    this.formId = this.data.FormId;
    this.uploadId = this.data.UploadId;
    this.sectionId = this.data.SectionId;
    this.selectedQId = this.data.QuestionID;
    console.log("parentid", this.sectionId)
    if (this.formId > 0 && this.uploadId > 0 && this.sectionId > 0) {
      this.LoadFormUploadDetails();
    }
  }

  onCloseClick() {
    if(this.answerValidation()) 
      this.dialogRef.close();
  }

  LoadJobRoles() {
    this._user.getUserJobRoles().subscribe(roles => {
      roles.forEach(r => {
        switch (r.Name) {
          case 'Supervisor':
            this.isSupervisour = true;
            break;
        }
      });
    })
  }
  UpdateInspectionSMU(event: any) {
    this.InspectionSMU = event.target.value;
    this._formService.UpdateUploadInspectionSMU(this.InspectionSMU, this.uploadId).subscribe(res => {
      if (res)
        this.toastr.success("Sucessfully Updated SMU")
    })
  }

  LoadFormUploadDetails() {
    this.UpdateExsitingAnswer = false;
    this._formService.GetDigitalFormUploadQuestionDetailsForSections(this.formId, this.uploadId, this.sectionId).subscribe(res => {
      console.log("result___1111", res)
      this.DigtalFormOverview = res;
      this.form = this.DigtalFormOverview.DigitalForms;
      this.formQSections = this.DigtalFormOverview.CategorySections
      this.formQuestions = this.DigtalFormOverview.Questions;
      this.questionTypes = this.DigtalFormOverview.QuestionTypes;
      this.flagTypes = this.DigtalFormOverview.FlagTypes;
      this.InspectionSMU = this.form.SMU;
      console.log('this.DigtalFormOverview', this.DigtalFormOverview);
      this.GetFormHeader();
      if (this.selectedQId > 0){
        this.fq = this.formQuestions.find(x => x.QuestionId == this.selectedQId);
        console.log('this.fq', this.fq);
        this.fqOld = JSON.parse(JSON.stringify(this.fq));
        console.log('this.fqOld', this.fqOld);
        this.isAnswerMandatory = this.fq.IsAnswerMandatory;
        this.parentCatName = this.formQSections.find(x => x.QuestionCatId == this.fq.QuestionCatId)?.ParentCatName ?? "";
        this.qCategoryName = this.formQSections.find(x => x.QuestionCatId == this.fq.QuestionCatId)?.QCategoryName ?? "";
      }
      //check implemt type  link Question
      if (this.fq.QuestionTypeId == 6) {
        this.SetDefaultSchemanticImage();
      }
      let index = this.formQuestions.findIndex(x => x.QuestionId == this.selectedQId)
      let checPrev = this.formQuestions[index - 1]
      if (checPrev) {
        //setShowPrevQButton(true)
        this.showPrevBtn = true;
      } else {
        //showNext
        //setShowPrevQButton(false)
        this.showPrevBtn = false;
      }
      let checkNext = this.formQuestions[index + 1]
      if (checkNext) {
        //setShowNextQButton(true)
        this.showNextBtn = true;
      } else {
        //setShowNextQButton(false)
        this.showNextBtn = false;
      }
      this.loadingobs = false;
    })
  }

  objectsEqual(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  checkAnyChanges(): boolean {
    return !this.objectsEqual(this.fq, this.fqOld);
  }

  isAnswered(): boolean {
    return this.fq.ModelAnswers.some(x => x.select === true);
  }

  isUnableToAnswer(): boolean {
    return this.fq.UnableToComplete === true;
  }

  isImagesAdded(): boolean {
    return this.fq.UploadImages != null && this.fq.UploadImages.length > 0;
  }

  isFlagSelected(): boolean {
    return this.fq.QuestionFlag != null && this.fq.QuestionFlag != 0;
  }

  isCommentAdded(): boolean {
    return this.fq.QuestionComment != null && this.fq.QuestionComment.length > 0;
  }

  GetColor() {
    if (this.fq.QuestionFlag != null && this.fq.QuestionFlag != 0) {
      let color = this.fq.FlagColor;
      return color;
    } else {
      return '#000000'
    }
  }

  GetObsFlagColor() {
    if (this.obsFlagId != null) {
      return this.obsFlagColour;
    } else {
      return '#000000'
    }
  }

  ChangeUnabletoObs(event: any) {
    console.log("obs__unable", event)
  }

  CompleteFlag() {
    this.fq.Flag = true;
    // if(this.fq.QuestionFlag!=null){
    //   let selectedtype = this.flagTypes.find(x=>x.ID== this.fq.QuestionFlag);
    //   this.fq.FlagColor=selectedtype.CompleteColor;
    console.log("flagggg Question", this.fq)

    const addSectionDialog = this._editPhotoDialog.open(ClearFlagDialogComponent, {

      data: {
        comment: this.fq.FlagClearComment,
        flagClear: this.fq.ClearFlag,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details.Id > 0) {
        this.fq.updateFlag = true;
        console.log("details___", details)
        if (details.Id == 1)//clear the flag
        {
          this.fq.ClearFlag = true;
          this.fq.FlagClearComment = details.Comment;
          let color = this.flagTypes.find(x => x.ID == this.fq.QuestionFlag);
          this.fq.FlagColor = color.CompleteColor;

        }
        if (details.Id == 2) { //update the flag comment
          this.fq.ClearFlag = false;
          this.fq.FlagClearComment = details.Comment;
        }
        if (details.Id == 3) {// reset the flag
          this.fq.ClearFlag = false;
          this.fq.FlagClearComment = details.Comment;
          let color = this.flagTypes.find(x => x.ID == this.fq.QuestionFlag);
          this.fq.FlagColor = color.Color;
          this.fq.QuestionFlag
        }
      } else {

      }
      if (this.fq.Flag == true) {
        this.UpdateQuestion();
      }
    });
  }

  CompleteFlagObs() {
    this.fq.Flag = true;
    console.log("flagggg Question", this.fq)
    var result = this.questionObservationInfo.reduce((unique, o) => {
      if (!unique.some(obj => obj.ObPointId === o.ObPointId && obj.ReadingNumber === o.ReadingNumber)) {
        unique.push(o);
      }
      return unique;
    }, []);
    console.log("result____", result);
    this.questionObservationInfo = result;
    this.questionObservationInfo.map(x => {
      if (x.ObPointId == this.selectedObservationPoint.ObservationPointId) {
        x.obsFlagID = 0;
        x.obsFlagColour = '#6FCF97';
        this.obsFlagId = 0;
        this.obsFlagColour = '#6FCF97';
      }
    })
  }

  GetFormHeader() {
    this._formService.GetDigitalFormHeaderFields(this.formId).subscribe(res => {
      console.log("HEader_", res)
      this.headerFormList = res;
      let arr_ = [...this.headerFormList];
      if (this.headerFormList.length < 6) {
        for (let index = this.headerFormList.length; index <= 6; index++) {
          let obj = {
            answer: "",
            fieldname: "",
            Id: 0,
            standardField: 0,
            qid: 0,
            order: 0,
          }
          arr_.push(obj);
        }
        this.headerFormList = arr_;
      }
      this.headerFormList.map(x => {
        if (x.standardField == 1)
          x.answer = this._crypto.decrypt(this.form.Inspector);
        if (x.standardField == 2)
          x.answer = this.form.RevisionNo;
        if (x.standardField == 3)
          x.answer = this.form.FormStartDate;
        if (x.standardField == 4)
          x.answer = this.form.EQCustomer + '/' + this.form.EQJobsite;
        if (x.standardField == 5)
          x.answer = this.form.Serial;
      })
      this.formQuestions.map(q => {
        let check = this.headerFormList.find(y => y.qid == q.QuestionId);
        if (check) {
          check.fieldname = q.QTitle;
          check.answer = q.ModelAnswers[0].Answer;
        }
      })
    })
  }

  //set impment type Question
  SetDefaultSchemanticImage() {
    this.obsDetails = [];
    this.CopyobsDetails = [];
    this.schematicImage = this.fq.SchematicList[0]?.schematic_attachement;
    this.schematicImageId = this.fq.SchematicList[0]?.schematic_auto;
    let arrayobs = [];
    let arr_ = [];
    if (this.fq.ModelAnswers != null && this.fq.ModelAnswers.length > 0) {
      this.fq.ModelAnswers.map(r => {
        r.Components.map(x => {
          console.log("x__", x)
          arr_.push(x);
          if (x.ObservationPoint != null) {
            if (x.ObservationPoint.length > 0 && x.ObservationPoint != null) {
              x.ObservationPoint.map(ob => {
                if (ob.schematic_auto == this.fq.SchematicList[0].schematic_auto) {
                  arrayobs.push(ob);
                }
              })
            }
          }
        })
      })
      this.obsDetails = arrayobs;
      this.CopyobsDetails = arrayobs;
      this.componentList = arr_;
      if (this.obsDetails.length > 0) {
        this.obsDetails[0].selected = true;
        this.SelectObPoint(this.obsDetails[0]);
      }
    }
  }

  LoadNextQuestion() {
    this.diabledFlag = true;
    this.validation = true;
    if (this.fq.QuestionTypeId == 6) {
      console.log("Selectedobs", this.selectedObservationPoint)
      if (this.selectedObservationPoint.IsAnswer == true) {
        if ((this.selectedObservationPoint.observationPointTypeId == 3 || this.selectedObservationPoint.observationPointTypeId == 4) && this.eval == null) {
          this.validation = false;
          this.toastr.alert("Need to select evaluation For this Observation point")
        } else if ((this.selectedObservationPoint.observationPointTypeId == 1 || this.selectedObservationPoint.observationPointTypeId == 2) && this.measurement == null) {
          this.validation = false;
          this.toastr.alert("Need Measurement For this Observation point")
        }
      }
      if (this.selectedObservationPoint.IsImage == true) {
        if (this.obImages === null) {
          this.validation = false;
          this.toastr.alert("Need at least one Image for this Observation point")
          //need to have measurement

        }
      }
    }
    // const canNavigate = this.validation === true && (this.fq.QuestionTypeId === 6 || this.answerValidation());
    if (this.validation == true) {
      if(this.answerValidation()){
        if (this.fq.Flag == true) {
          //this.UpdateQuestion();
        this.setNextButon();
        this.LoadFormUploadDetails();
      }
      else {
        this.setNextButon();
      }
      }
    }
    this.parentCatName = this.formQSections.find(x => x.QuestionCatId == this.fq.QuestionCatId)?.ParentCatName ?? "";
    this.qCategoryName = this.formQSections.find(x => x.QuestionCatId == this.fq.QuestionCatId)?.QCategoryName ?? "";
  }

  LoadPreviousQuestion() {
    this.validation = true;
    if (this.fq.QuestionTypeId == 6) {
      console.log("Selectedobs", this.selectedObservationPoint)
      if (this.selectedObservationPoint.IsAnswer == true) {
        if ((this.selectedObservationPoint.observationPointTypeId == 3 || this.selectedObservationPoint.observationPointTypeId == 4) && this.eval == null) {
          this.validation = false;
          this.toastr.alert("Need to select evaluation For this Observation point")
        } else if ((this.selectedObservationPoint.observationPointTypeId == 1 || this.selectedObservationPoint.observationPointTypeId == 2) && this.measurement == null) {
          this.validation = false;
          this.toastr.alert("Need Measurement For this Observation point")
        }
      }
      if (this.selectedObservationPoint.IsImage == true) {
        if (this.obImages === null) {
          this.validation = false;
          this.toastr.alert("Need at least one Image for this Observation point")
        }
      }
    }
    //const canNavigate = this.validation === true && (this.fq.QuestionTypeId === 6 || this.answerValidation());
    if (this.validation == true) {
      if(this.answerValidation()){
      if (this.fq.Flag == true) {
          //this.UpdateQuestion();
        this.setPreviousButton();
        this.LoadFormUploadDetails();
      } else {
        this.setPreviousButton();
      }
    }
    }
    this.parentCatName = this.formQSections.find(x => x.QuestionCatId == this.fq.QuestionCatId)?.ParentCatName ?? "";
    this.qCategoryName = this.formQSections.find(x => x.QuestionCatId == this.fq.QuestionCatId)?.QCategoryName ?? "";
  }

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }

  openUploadEditImage(image: string) {
    const editPhotoModalRef = this._editPhotoDialog.open(EditPhotoDigitalComponent, {
      data: { photoWithExt: 'data:image/png;base64,' + image }
    });
    editPhotoModalRef.afterClosed().subscribe(res => {
      if (res != null) {
        console.log("updated", res)
        this.fq.Flag = true;
        let arr_ = [...this.fq.UploadImages];
        arr_ = arr_.filter(x => x != image);
        let editImg = res.photo;
        arr_.push(editImg);
        this.fq.UploadImages = arr_;
        if (this.fq.Flag == true) {
          this.UpdateQuestion();
        }
      }
    });
  }

  openEditObsImage(image: string) {
    const editPhotoModalRef = this._editPhotoDialog.open(EditPhotoDigitalComponent, {
      data: { photoWithExt: 'data:image/png;base64,' + image }
    });
    editPhotoModalRef.afterClosed().subscribe(res => {
      if (res != null) {
        console.log("updated", res)
        this.fq.Flag = true;
        this.fq.ObservationDetails.map(r => {
          if (r.ObPointId == this.selectedObservationPoint.ObservationPointId) {
            let arr_ = [...this.obImages];
            arr_ = arr_.filter(x => x != image);
            let editImg = res.photo;
            arr_.push(editImg);
            console.log("filter___", arr_)
            this.obImages = arr_;
            r.obsImages = this.obImages;
            console.log("after__", this.obImages)
            console.log("after__", arr_)
          }
        })
      }
    });
  }

  EditImage(qId: number, photo: string, Question: DigitalFormQuestionsVM) {
    const editPhotoModalRef = this._editPhotoDialog.open(EditPhotoDigitalComponent, {
      data: { photoWithExt: 'data:image/png;base64,' + photo }
    });
    editPhotoModalRef.afterClosed().subscribe(res => {
      if (res != null) {
        Question.EditedQuestionImage = res.photo;
        Question.Flag = true;
      }
    });
  }

  UpdateFreetextOrNumber(event: any, Question: DigitalFormQuestionsVM) {
    console.log(event.target.value, Question)
    this.fq = Question;
    this.fq.Flag = true;
    var getMax100limit =  Question.ModelAnswers;
    if (Question.inspectorId != null && this.isSupervisour == false) {
      this.UpdateExsitingAnswer = true;
      this.fq.QuestionFlag = 3;
      let updatansFlag = this.flagTypes.find(x => x.ID == 3);
      this.fq.FlagColor = updatansFlag.Color;
      this.fq.updateFlag = true;
      this.fq.ClearFlag = false;
    }
    Question.ModelAnswers.map(x => {
      x.Answer = event.target.value;
      x.QuestionName = Question.QTitle;
      x.select = true;
    })
    //let verify to triggered the Flag event
    if(Number(event.target.value) >= getMax100limit[0].EndWorn){
      console.warn("Flag Triggered");
      let updatansFlag = this.flagTypes.find(x => x.ID == 1);
      this.fq.FlagColor = updatansFlag.Color;
      this.fq.updateFlag = true;
      this.fq.ClearFlag = false;
      this.diabledFlag =false;
      var getFlag= this.flagTypes.find(x => x.ID == 1)
      this.UpdateFlag(getFlag,Question)
    }else{
      this.diabledFlag =true;
      this.GetObsFlagColor();
      this.fq = Question;
    Question.Flag = true;
    this.fq.QuestionFlag = 0;
    this.fq.FlagColor = "#000000";
    this.fq.ClearFlag = true;
    this.fq.updateFlag = true;
      if (this.fq.Flag == true) {
      this.UpdateQuestion();
    }
  }
  }
  SelectAnswer(value: number, AnswerId: number, Question: DigitalFormQuestionsVM) {
    console.log("valuee", value)
    Question.Flag = true;
    if (Question.inspectorId != null && this.isSupervisour == false) {
      this.UpdateExsitingAnswer = true;
      this.fq.QuestionFlag = 3;
      let updatansFlag = this.flagTypes.find(x => x.ID == 3);
      this.fq.FlagColor = updatansFlag.Color;
      this.fq.updateFlag = true;
      this.fq.ClearFlag = false;
    }
    Question.ModelAnswers.forEach(x => {
      x.select = x.AnswerId === AnswerId;
    });
    if (this.fq.Flag === true) {
      this.UpdateQuestion();
    }
    // Question.ModelAnswers.map(x => {
    //   if (x.AnswerId == AnswerId) {
    //     x.select = true;
    //   } else {
    //     x.select = false;
    //   }
    //   if (this.fq.Flag == true) {
    //     this.UpdateQuestion();
    //   }
    // })
  }

  SelectAnswerRadio(value: number, AnswerId: number, Question: DigitalFormQuestionsVM) {
    console.log("valuee", value)
    Question.Flag = true;
    let AnswerId1 = Question.ModelAnswers[0].AnswerId;
    let AnswerId2 = Question.ModelAnswers[1].AnswerId;
    if (Question.inspectorId != null && this.isSupervisour == false) {
      this.UpdateExsitingAnswer = true;
      this.fq.QuestionFlag = 3;
      let updatansFlag = this.flagTypes.find(x => x.ID == 3);
      this.fq.FlagColor = updatansFlag.Color;
      this.fq.updateFlag = true;
      this.fq.ClearFlag = false;
    }
    Question.ModelAnswers.map(x => {
      if (x.AnswerId == AnswerId) {
        x.select = true;
        if (AnswerId2 == AnswerId) {
          let commentaaddedFlag = this.flagTypes.find(x => x.ID == 1);
          //new comment update
          console.log("False select", commentaaddedFlag)
          this.fq.QuestionFlag = commentaaddedFlag.ID;
          this.fq.FlagColor = commentaaddedFlag.Color;
          this.fq.ClearFlag = false;
          this.fq.updateFlag = true;
          //this.fq.IsAnswerMandatory = false;
        }
      } else {
        x.select = false;
      }
      if (this.fq.Flag == true) {
        this.UpdateQuestion();
      }
    })
    if (AnswerId1 > AnswerId2) {
    }
  }
  UpdateFlag(type: FlagTypesVM, Question: DigitalFormQuestionsVM) {
    console.log("type", type)
    this.fq = Question;
    Question.Flag = true;
    this.fq.QuestionFlag = type.ID;
    this.fq.FlagColor = type.Color;
    this.fq.ClearFlag = false;
    this.fq.updateFlag = true;
    if (this.fq.Flag == true) {
      this.UpdateQuestion();
    }
  }

  UpdateFlagObs(type: FlagTypesVM) {
    console.log("selectedobs and Flag", this.fq.Flag, this.selectedObservationPoint, this.questionObservationInfo, type)
    this.fq.Flag = true;
    this.questionObservationInfo.map(x => {
      if (x.ObPointId == this.selectedObservationPoint.ObservationPointId) {
        x.obsFlagID = type.ID;
        x.obsFlagColour = type.Color;
        x.obsClearFlag = false;
        x.obsUpdateFlag = true;
        this.obsFlagColour = type.Color;
        this.obsFlagId = type.ID;
        //this.ReadingNum=1;
      }
    })
    this.fq.ObservationDetails = this.questionObservationInfo
  }
  ChangeFlagToActionRequied() {
    console.log("Resily_", this.fq.UnableToComplete)
    this.fq.Flag = true;
    if (this.fq.inspectorId != null && this.isSupervisour == false) {
      this.UpdateExsitingAnswer = true;
      this.fq.QuestionFlag = 3;
      let updatansFlag = this.flagTypes.find(x => x.ID == 3);
      this.fq.FlagColor = updatansFlag.Color;
      this.fq.updateFlag = true;
      this.fq.ClearFlag = false;
    }
    if (this.fq.UnableToComplete) {
      let commentaaddedFlag = this.flagTypes.find(x => x.ID == 1);
      //new comment update
      //console.log("commentaaddedFlag_toActionRequied", commentaaddedFlag)
      this.fq.QuestionFlag = commentaaddedFlag.ID;
      this.fq.FlagColor = commentaaddedFlag.Color;
      this.fq.ClearFlag = false;
      this.fq.updateFlag = true;
    }
    if(!this.fq.UnableToComplete){
      this.fq.QuestionFlag = 0;
      this.fq.FlagColor = '#000000';
      this.fq.ClearFlag = false;
      this.fq.updateFlag = true;
    }
    if (this.fq.Flag == true) {
        this.UpdateQuestion();
    }
  }

  ChangeFlagToActionRequiedWIP() {
    console.log("Resily_", this.fq.WorkInProgress)
    this.fq.Flag = true;
    if (this.fq.inspectorId != null && this.isSupervisour == false) {
      this.UpdateExsitingAnswer = true;
      this.fq.QuestionFlag = 3;
      let updatansFlag = this.flagTypes.find(x => x.ID == 3);
      this.fq.FlagColor = updatansFlag.Color;
      this.fq.updateFlag = true;
      this.fq.ClearFlag = false;
    }
    if (this.fq.WorkInProgress) {
      let commentaaddedFlag = this.flagTypes.find(x => x.ID == 1);
      //new comment update
      //console.log("commentaaddedFlag_toActionRequied", commentaaddedFlag)
      this.fq.QuestionFlag = commentaaddedFlag.ID;
      this.fq.FlagColor = commentaaddedFlag.Color;
      this.fq.ClearFlag = false;
      this.fq.updateFlag = true;
    }
    if(!this.fq.WorkInProgress){
      this.fq.QuestionFlag = 0;
      this.fq.FlagColor = '#000000';
      this.fq.ClearFlag = false;
      this.fq.updateFlag = true;
    }
    if (this.fq.Flag == true) {
        this.UpdateQuestion();                                                                                                                                          
    }
  }


  ChangeFlag() {
    this.fq.Flag = true;
    if (this.fq.inspectorId != null && this.isSupervisour == false) {
      this.UpdateExsitingAnswer = true;
      this.fq.QuestionFlag = 3;
      let updatansFlag = this.flagTypes.find(x => x.ID == 3);
      this.fq.FlagColor = updatansFlag.Color;
      this.fq.updateFlag = true;
      this.fq.ClearFlag = false;
    }
    if (this.fq.Flag == true) {
      this.UpdateQuestion();
    }
  }

  OpenInstructions(instruction: string) {
    const addSectionDialog = this._editPhotoDialog.open(FlagCommentComponent, {
      data: {
        isInstructions: true,
        comment: instruction,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
    });
  }
  OpenFlagComment() {
    const addSectionDialog = this._editPhotoDialog.open(FlagCommentComponent, {
      data: {
        comment: this.fq.FlagClearComment,
        exsitingcomment: this.fq.FlagComment,
        header: "Flag History",
        isInstructions: false,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details.Id > 0) {
        this.fq.FlagClearComment = details.Comment;
        this.fq.updateFlag = true;
        this.fq.Flag = true;
        if (this.fq.Flag == true) {
          this.UpdateQuestion();
        }
      }
      console.log("details___", details)
    });
  }


  OpenObsFlagComment() {
    const addSectionDialog = this._editPhotoDialog.open(FlagCommentComponent, {
      data: {
        //comment: this.obsFlagClearComment,
        exsitingcomment: this.obsFlagComment,
        header: "Flag History",
        isInstructions: false,
      },
      height: '700px',
      width:  '860px'
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details.Id > 0) {
        this.fq.Flag = true;
        this.questionObservationInfo.map(x => {
          if (x.ObPointId == this.selectedObservationPoint.ObservationPointId) {
            x.obsFlagComment = details.Comment;
            x.obsClearFlag = true;
            //this.obsFlagClearComment = details.Comment;
          }
        })
      }
      console.log("details___", details)
    });
  }

  Imagelist: string[] = [];
  image: string;
  ViewAll() {
    //this._router.navigate(['/digitalform/fill', this.formId, this.uploadId]);
    this._pref.GetReplaceExistingTabStatus().subscribe(res => {
      if (res == "True") {
        this._router.navigate(['/digitalform/fill', this.formId, this.uploadId]);
      } else {
        window.open('digitalform/fill/' + this.formId + '/' + this.uploadId, '_blank');
      }
    });
  }

  //  photo upload
  // onSelectPhoto(event, Question: DigitalFormQuestionsVM) {
  //   Question.Flag = true;
  //   if (event.target.files && event.target.files[0]) {
  //     this.Imagelist = [];
  //     var reader = new FileReader();
  //     reader.readAsDataURL(event.target.files[0]); // read file as data url
  //     reader.onload = (event: any) => { // called once readAsDataURL is completed
  //       var imageUrl = (event.target["result"]).split(',');
  //       this.Imagelist.push(imageUrl[1]);
  //       this.image = imageUrl[1];
  //       if (Question.UploadImages == null) {
  //         Question.UploadImages = this.Imagelist;

  //       } else {
  //         Question.UploadImages.push(this.image)
  //       }
  //       if (this.fq.Flag == true) {
  //         this.UpdateQuestion();
  //       }
  //     }
  //   }
  // }

async onSelectPhoto(event: any, Question: DigitalFormQuestionsVM) {

  Question.Flag = true;

  if (!(event.target.files && event.target.files[0])) {
    return;
  }

  const file = event.target.files[0];

  this.Imagelist = [];

  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();

  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {

    const reader = new FileReader();

    reader.onload = (e: any) => {

      const imageUrl = (e.target.result as string).split(',');

      this.Imagelist.push(imageUrl[1]);

      this.image = imageUrl[1];

      if (Question.UploadImages == null) {
        Question.UploadImages = this.Imagelist;
      } else {
        Question.UploadImages.push(this.image);
      }

      if (this.fq.Flag === true) {
        this.UpdateQuestion();
      }

    };

    reader.readAsDataURL(f);
  };

  try {

    if (isHeic) {

      console.log("HEIC detected");

      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg", // Change to 'toType' if required by your heic-to version
        quality: 0.8
      });

      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );

      processFile(convertedFile);

    } else {

      processFile(file);

    }

  } catch (err: any) {

    console.error("HEIC conversion failed", err);

    this.toastr.error(
      "Failed to convert HEIC image. Please try a different image."
    );

  }

  event.target.value = null;
}

// onSelectPhoto(event: any, Question: DigitalFormQuestionsVM) {
//   Question.Flag = true;
//   if (event.target.files && event.target.files[0]) {
//     let file = event.target.files[0];
//     this.Imagelist = [];
//     const isHeic =
//       file.type === "image/heic" ||
//       file.name.toLowerCase().endsWith(".heic");
//     const processFile = (f: File) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(f);
//       reader.onload = (e: any) => {
//         const imageUrl = (e.target.result as string).split(',');
//         this.Imagelist.push(imageUrl[1]);
//         this.image = imageUrl[1];
//         if (Question.UploadImages == null) {
//           Question.UploadImages = this.Imagelist;
//         } else {
//           Question.UploadImages.push(this.image);
//         }
//         if (this.fq.Flag === true) {
//           this.UpdateQuestion();
//         }
//       };
//     };
//     if (isHeic) {
//       (heic2any as any).default({
//         blob: file,
//         toType: "image/jpeg",
//         quality: 0.8
//       })
//       .then((result: any) => {
//         const convertedBlob = Array.isArray(result) ? result[0] : result;
//         const convertedFile = new File([convertedBlob], "converted.jpg", {
//           type: "image/jpeg"
//         });
//         processFile(convertedFile);
//       })
//       .catch((err: any) => {
//         console.error("HEIC conversion failed", err);
//         this.toastr.error("Failed to convert HEIC image. Please try a different image.");
//       });
//     } else {
//       processFile(file);
//     }
//     event.target.value = null;
//   }
// }

  onSelectObs(event, Question: DigitalFormQuestionsVM) {
    Question.Flag = true;
    if (event.target.files && event.target.files[0]) {
      this.Imagelist = [];
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event: any) => { // called once readAsDataURL is completed
        var imageUrl = (event.target["result"]).split(',');
        this.Imagelist.push(imageUrl[1]);
        this.image = imageUrl[1];
        if (this.obImages == null) {
          this.obImages = this.Imagelist;
        } else {
          this.obImages.push(this.image)
        }
        // this.fq.ObservationDetails.map(r=>{
        //   if(r.ObPointId== this.selectedObservationPoint.ObservationPointId){
        //     r.obsImages=this.obImages;
        //   }
        // })
        //new code
        if (this.selectedObservationPoint.observationPointTypeId != 3 && this.selectedObservationPoint.observationPointTypeId != 4) {
          if (this.selectedObservationPoint.numberOfReading == 1) {
            let arry_ = [];
            let obj = {
              ObPointId: this.selectedObservationPoint.ObservationPointId,
              ReadingNumber: 1,
              Measurement: this.measurement,
              Percentage: 0,
              Uom: this.UoM,
              obsImages: this.obImages,
              comment: this.obsComment,
            }
            arry_.push(obj);
            let arracpy = [];

            console.log("this.questionObservationInfo__", this.questionObservationInfo)
            if (this.questionObservationInfo == null || this.questionObservationInfo == undefined) {
              this.questionObservationInfo = arry_;
            } else {
              let check = this.questionObservationInfo.find(q => q.ObPointId == this.selectedObservationPoint.ObservationPointId && q.ReadingNumber.toString() == "1");
              if (check) {
                //check.Measurement = measurement_;
                check.UoM = this.UoM;
                check.obsImages = this.obImages;
                check.comment = this.obsComment;
              } else {
                arracpy = this.questionObservationInfo;
                arracpy = arracpy.concat(arry_);
                this.questionObservationInfo = arracpy;
              }
            }
            this.fq.ObservationDetails = this.questionObservationInfo;
          } else {
            let arry_ = [];
            let obj = {
              ObPointId: this.selectedObservationPoint.ObservationPointId,
              ReadingNumber: this.ReadingNum,
              Measurement: this.measurement,
              Uom: this.UoM,
              obsImages: this.obImages,
              comment: this.obsComment,
            }
            arry_.push(obj);
            let arracpy = [];
            if (this.questionObservationInfo == null) {
              this.questionObservationInfo = arry_;
            } else {
              let check = this.questionObservationInfo.find(q => q.ObPointId == this.selectedObservationPoint.ObservationPointId && q.ReadingNumber.toString() == this.ReadingNum.toString());
              if (check) {
                //check.Measurement = measurement_;
                check.UoM = this.UoM;
                check.obsImages = this.obImages;
                check.comment = this.obsComment;
              } else {
                arracpy = this.questionObservationInfo;
                arracpy = arracpy.concat(arry_);
                this.questionObservationInfo = arracpy;
              }
            }
            this.fq.ObservationDetails = this.questionObservationInfo;
          }
        }
        else {
          if (this.selectedObservationPoint.numberOfReading == 1) {
            let arry_ = [];
            let obj = {
              ObPointId: this.selectedObservationPoint.ObservationPointId,
              ReadingNumber: 1,
              Measurement: 0,
              Percentage: 0,
              Uom: this.UoM,
              obsImages: this.obImages,
              comment: this.obsComment,
            }
            arry_.push(obj);
            let arracpy = [];
            console.log("this.questionObservationInfo__", this.questionObservationInfo)
            if (this.questionObservationInfo == null || this.questionObservationInfo == undefined) {
              this.questionObservationInfo = arry_;
            } else {
              let check = this.questionObservationInfo.find(q => q.ObPointId == this.selectedObservationPoint.ObservationPointId && q.ReadingNumber.toString() == "1");
              if (check) {
                //check.Measurement = measurement_;
                check.UoM = this.UoM;
                check.obsImages = this.obImages;
                check.comment = this.obsComment;
              } else {
                arracpy = this.questionObservationInfo;
                arracpy = arracpy.concat(arry_);
                this.questionObservationInfo = arracpy;
              }
            }
            this.fq.ObservationDetails = this.questionObservationInfo;
          }
        }
        //end new code
      }
    }

    var result = this.questionObservationInfo.reduce((unique, o) => {
      if (!unique.some(obj => obj.ObPointId === o.ObPointId && obj.ReadingNumber === o.ReadingNumber)) {
        unique.push(o);
      }
      return unique;
    }, []);

    console.log("result____", result);
    this.questionObservationInfo = result;
    this.fq.ObservationDetails = this.questionObservationInfo;
    console.log("ImagesList", this.fq)
  }


  ChnageFlag() {
    this.fq.Flag = true;
    let commentaaddedFlag = this.flagTypes.find(x => x.ID == 4);
    //new comment update
    console.log("commentaaddedFlag", commentaaddedFlag)
    //this.fq = Question;
    //Question.Flag = true;
    this.fq.QuestionFlag = commentaaddedFlag.ID;
    this.fq.FlagColor = commentaaddedFlag.Color;
    this.fq.ClearFlag = false;
    this.fq.updateFlag = true;
    if (this.fq.Flag == true) {
      this.UpdateQuestion();
    }
  }

  deleteimage(image: string, Question: DigitalFormQuestionsVM) {
    this.fq.UploadImages = Question.UploadImages.filter(x => x != image);
    this.fq.Flag = true;
    if (this.fq.Flag == true) {
      this.UpdateQuestion();
    }
  }

  deleteObsimage(image: string, Question: DigitalFormQuestionsVM) {
    this.fq.Flag = true;
    Question.ObservationDetails.map(r => {
      console.log("selected delete", r.ObPointId, this.selectedObservationPoint.ObservationPointId)
      if (r.ObPointId == this.selectedObservationPoint.ObservationPointId) {
        this.obImages = this.obImages.filter(x => x != image);
        r.obsImages = this.obImages;
      }
    })
  }

  UpdateQuestion() {
    console.log("this.questionInfo ", this.questionObservationInfo)
    //new code
    if (this.questionObservationInfo != null && this.fq.QuestionTypeId == 6) {
      var result = this.questionObservationInfo.reduce((unique, o) => {
        if (!unique.some(obj => obj.ObPointId === o.ObPointId && obj.ReadingNumber === o.ReadingNumber)) {
          unique.push(o);
        }
        return unique;
      }, []);
      console.log("result____", result);
      this.questionObservationInfo = result;
      this.fq.ObservationDetails = this.questionObservationInfo;
    }
    this.loadingobs = true;
    this.QuestionList = [];
    this.QuestionList.push(this.fq);
    let UpdateQuestions = new UpdateQuestion();
    UpdateQuestions.FormId = this.formId;
    UpdateQuestions.UploadId = this.uploadId;
    UpdateQuestions.ParentCatId = this.sectionId;
    UpdateQuestions.Questions = this.QuestionList;
    UpdateQuestions.IsSupervisour = this.isSupervisour;
    this.Loading = true;
    console.log("this.fq______ on save", this.fq)
    this._formService.UpdateQuestionsForSpecifcCategory(UpdateQuestions).subscribe(res => {
      if (res == true) {
        let array_ = [...this.formQuestions];
        this.fq.Flag = false;
        array_.map(x => {
          if (x.QuestionId == this.fq.QuestionId) {
            x.Flag = false;
            this.fq.Flag = false;
            this.selectedQId = x.QuestionId;
          }
        })
        this.formQuestions = array_;
        this.toastr.success("Sucessfully Updated the Question")
        //this.LoadFormUploadDetails();
        this.Loading = false;
      } else {
        this.toastr.error("Unable to Update the Question")
        this.loadingobs = false;
      }
    })
  }

  ReturnToSummary() {
    console.log("return to summary__", this.fq.Flag)
    this.onCloseClick();
    // const answered = this.isAnswered();
    // const imagesAdded = this.isImagesAdded();
    // const isFlagSelected = this.isFlagSelected();
    // const commentAdded = this.isCommentAdded();
    // const currentIndex = this.DigtalFormOverview.Questions.indexOf(this.fq);
    // const IsLastIndex = currentIndex == this.DigtalFormOverview.Questions.length -1;
    // //console.log("lastIndex__", lastIndex, currentIndex);
    // if (this.fq.IsAnswerMandatory && !commentAdded && !answered && !imagesAdded && !isFlagSelected && !IsLastIndex ) {
    //   this.toastr.error("This Question is mandatory to answer before proceeding");
    //   return;
    // }
    //if (this.fq.Flag == true) {
      //this.UpdateQuestion();
     // this.onCloseClick();
      // this._router.navigate(['/digitalform/fill', this.formId, this.uploadId]);
      //this._pref.GetReplaceExistingTabStatus().subscribe(res => {
       // if (res == "True") {
          //this._router.navigate(['/digitalform/fill', this.formId, this.uploadId]);
      //  }
        //  else {
        //   window.open('digitalform/fill/' + this.formId + '/' + this.uploadId);
        // }
     // });
  // } else {
     // this.onCloseClick();
      //this._router.navigate(['/digitalform/fill', this.formId, this.uploadId]);
      //this._pref.GetReplaceExistingTabStatus().subscribe(res => {
       // if (res == "True") {
          //this._router.navigate(['/digitalform/fill', this.formId, this.uploadId]);
      //  } 
        // else {
        //   window.open('digitalform/fill/' + this.formId + '/' + this.uploadId, '_blank');
        // }
      //});
    //}
  }

  //TT-10202
  //To check answers given for mandatory questions or not and if not then show message.
  answerValidation(){
    const answered = this.isAnswered();
    const imagesAdded = this.isImagesAdded();
    const isFlagSelected = this.isFlagSelected();
    const commentAdded = this.isCommentAdded();
    const currentIndex = this.DigtalFormOverview.Questions.indexOf(this.fq);
    const IsLastIndex = currentIndex == this.DigtalFormOverview.Questions.length -1;
    const unableToAnswer = this.isUnableToAnswer();
    //console.log("lastIndex__", lastIndex, currentIndex);
    if (this.fq.IsAnswerMandatory && !commentAdded && !answered && !imagesAdded && !isFlagSelected && !IsLastIndex ) {
      this.toastr.alert("This Question is mandatory to answer before proceeding");
      return false;
    }
    if(this.fq.IsAnswerMandatory === true && !commentAdded && !answered && !imagesAdded && unableToAnswer && isFlagSelected){ 
      this.toastr.alert("A comment is required, Please provide the reason you are unable to complete this task."); 
      return false; // STOP — do not go next 
    }
    else 
      return true;
  }

  LoadNextObs() {
    //this.selectedUOM= this.PrefUOM
    this.validation = true;
    console.log("Selectedobs", this.selectedObservationPoint)
    if (this.selectedObservationPoint.IsAnswer == true) {
      if ((this.selectedObservationPoint.observationPointTypeId == 3 || this.selectedObservationPoint.observationPointTypeId == 4) && this.eval == null) {
        //need to have measurement
        this.validation = false;
        this.toastr.alert("Need to select evaluation For this Observation point")
      } else if ((this.selectedObservationPoint.observationPointTypeId == 1 || this.selectedObservationPoint.observationPointTypeId == 2) && this.measurement == null) {
        this.validation = false;
        this.toastr.alert("Need Measurement For this Observation point")
      }
    }
    if (this.selectedObservationPoint.IsImage == true) {
      if (this.obImages === null) {
        this.validation = false;
        this.toastr.alert("Need at least one Image for this Observation point")
        //need to have measurement
      }
    }
    if (this.validation == true) {
      if (this.fq.Flag == true) {
        this.UpdateQuestion();
      }
      if (this.currentIndex + 1 >= this.obsDetails.length) {
        this.showobnext = false;
      } else {
        this.showobprev = true;
        this.showobnext = true;
        console.log("obsDetails__", this.obsDetails)
        this.obsDetails.map((x, i) => {
          if (x.selected == true) {
            this.currentIndex = i + 1;
            x.selected = false;
          }
        })
        let selectedObs = this.obsDetails.find((x, i) => this.currentIndex == i);
        this.SelectObPoint(selectedObs);
      }
    }
  }

  LoadPreviousObs() {
    this.selectedUOM = this.PrefUOM
    this.validation = true;
    console.log("Selectedobs_Pre", this.selectedObservationPoint)
    if (this.selectedObservationPoint.IsAnswer == true) {
      if ((this.selectedObservationPoint.observationPointTypeId == 3 || this.selectedObservationPoint.observationPointTypeId == 4) && this.eval == null) {
        //need to have measurement
        this.validation = false;
        this.toastr.alert("Need to select evaluation For this Observation point")
      } else if ((this.selectedObservationPoint.observationPointTypeId == 1 || this.selectedObservationPoint.observationPointTypeId == 2) && this.measurement == null) {
        this.validation = false;
        this.toastr.alert("Need Measurement For this Observation point")
      }
    }
    if (this.selectedObservationPoint.IsImage == true) {
      if (this.obImages == null) {
        this.validation = false;
        //need to have measurement
        this.toastr.alert("Need at least one Image for this Observation point")
      }
    }
    if (this.validation == true) {
      if (this.currentIndex - 1 < 0) {
        this.showobprev = false;
      } else {
        this.showobnext = true;
        this.showobprev = true;
        console.log("obsDetails__", this.obsDetails)
        this.obsDetails.map((x, i) => {
          if (x.selected == true) {
            this.currentIndex = i - 1;
            x.selected = false;
          }
        })
        let selectedObs = this.obsDetails.find((x, i) => this.currentIndex == i);
        this.SelectObPoint(selectedObs);
      }
    }
  }

  ChangeComment() {
    this.fq.Flag = true;
    let commentaaddedFlag = this.flagTypes.find(x => x.ID == 4);
    //new comment update
    console.log("commentaaddedFlag_obs", commentaaddedFlag)
    //this.fq = Question;
    //Question.Flag = true;

    this.fq.QuestionFlag = commentaaddedFlag.ID;
    this.fq.FlagColor = commentaaddedFlag.Color;
    this.fq.ClearFlag = false;
    this.fq.updateFlag = true;

    if (this.selectedObservationPoint.observationPointTypeId != 3 && this.selectedObservationPoint.observationPointTypeId != 4) {
      if (this.selectedObservationPoint.numberOfReading == 1) {
        let arry_ = [];
        let obj = {
          ObPointId: this.selectedObservationPoint.ObservationPointId,
          ReadingNumber: 1,
          Measurement: this.measurement,
          Percentage: 0,
          Uom: this.UoM,
          obsImages: this.obImages,
          comment: this.obsComment,
        }
        arry_.push(obj);
        let arracpy = [];
        console.log("this.questionObservationInfo__", this.questionObservationInfo)
        if (this.questionObservationInfo == null || this.questionObservationInfo == undefined) {
          this.questionObservationInfo = arry_;
        } else {
          let check = this.questionObservationInfo.find(q => q.ObPointId == this.selectedObservationPoint.ObservationPointId && q.ReadingNumber.toString() == "1");
          if (check) {
            //check.Measurement = measurement_;
            check.UoM = this.UoM;
            check.obsImages = this.obImages;
            check.comment = this.obsComment;
          } else {
            arracpy = this.questionObservationInfo;
            arracpy = arracpy.concat(arry_);
            this.questionObservationInfo = arracpy;
          }
        }
        this.fq.ObservationDetails = this.questionObservationInfo;
      } else {
        let arry_ = [];
        let obj = {
          ObPointId: this.selectedObservationPoint.ObservationPointId,
          ReadingNumber: this.ReadingNum,
          Measurement: this.measurement,
          Uom: this.UoM,
          obsImages: this.obImages,
          comment: this.obsComment,
        }
        arry_.push(obj);
        let arracpy = [];
        if (this.questionObservationInfo == null) {
          this.questionObservationInfo = arry_;
        } else {
          let check = this.questionObservationInfo.find(q => q.ObPointId == this.selectedObservationPoint.ObservationPointId && q.ReadingNumber.toString() == this.ReadingNum.toString());
          if (check) {
            //check.Measurement = measurement_;
            check.UoM = this.UoM;
            check.obsImages = this.obImages;
            check.comment = this.obsComment;
          } else {
            arracpy = this.questionObservationInfo;
            arracpy = arracpy.concat(arry_);
            this.questionObservationInfo = arracpy;
          }
        }
        this.fq.ObservationDetails = this.questionObservationInfo;
      }
    }
    else {
      if (this.selectedObservationPoint.numberOfReading == 1) {
        let arry_ = [];
        let obj = {
          ObPointId: this.selectedObservationPoint.ObservationPointId,
          ReadingNumber: 1,
          Measurement: 0,
          Percentage: 0,
          Uom: this.UoM,
          obsImages: this.obImages,
          comment: this.obsComment,
        }
        arry_.push(obj);
        let arracpy = [];
        console.log("this.questionObservationInfo__", this.questionObservationInfo)
        if (this.questionObservationInfo == null || this.questionObservationInfo == undefined) {
          this.questionObservationInfo = arry_;
        } else {
          let check = this.questionObservationInfo.find(q => q.ObPointId == this.selectedObservationPoint.ObservationPointId && q.ReadingNumber.toString() == "1");
          if (check) {
            //check.Measurement = measurement_;
            check.UoM = this.UoM;
            check.obsImages = this.obImages;
            check.comment = this.obsComment;
          } else {
            arracpy = this.questionObservationInfo;
            arracpy = arracpy.concat(arry_);
            this.questionObservationInfo = arracpy;
          }
        }
        this.fq.ObservationDetails = this.questionObservationInfo;
      }
    }
  }

  UpdateObsUnable(event: any) {
    this.obsUnable = event.checked;
    this.selectedObservationPoint.obsUnabletoComplete = event.checked;
    console.log("this.obsUnable______", this.obsUnable, this.selectedObservationPoint.obsUnabletoComplete, event.checked)
    this.fq.Flag = true;
    this.obsDetails.map(x => {
      if (x.ObservationPointId == this.selectedObservationPoint.ObservationPointId) {
        x.obsUnabletoComplete = this.obsUnable;
        this.selectedObservationPoint.obsUnabletoComplete = this.obsUnable;
        this.SelectObPoint(x);
      }
    })
    var result = this.questionObservationInfo.reduce((unique, o) => {
      if (!unique.some(obj => obj.ObPointId === o.ObPointId && obj.ReadingNumber === o.ReadingNumber)) {
        unique.push(o);
      }
      return unique;
    }, []);
    console.log("result____", result);
    this.questionObservationInfo = result;
    console.log("this.questionObservationInfo__", this.questionObservationInfo)
    this.obsUnable = event.checked;
    if (event.checked == true) {
      let commentaaddedFlag = this.flagTypes.find(x => x.ID == 1);
      console.log("obsUnable___", commentaaddedFlag)
      this.obsFlagId = commentaaddedFlag.ID;
      this.obsFlagColour = commentaaddedFlag.Color;
      console.log("obsUnable___", this.obsFlagId, this.obsFlagColour)
      // this.fq.ClearFlag=false;
      //this.fq.updateFlag=true;
    }
    this.selectedObservationPoint.obsUnabletoComplete = this.obsUnable;
    if (this.selectedObservationPoint.numberOfReading > 0) {
      let arry_ = [];
      let obj = {
        ObPointId: this.selectedObservationPoint.ObservationPointId,
        ReadingNumber: 1,
        Measurement: 0,
        Percentage: 0,
        Uom: this.UoM,
        obsImages: this.obImages,
        comment: this.obsComment,
        obsUnabletoComplete: this.selectedObservationPoint.obsUnabletoComplete,
        obsFlagID: this.obsFlagId,
        obsFlagColour: this.obsFlagColour,
      }
      arry_.push(obj);
      let arracpy = [];
      if (this.questionObservationInfo == null || this.questionObservationInfo == undefined) {
        this.questionObservationInfo = arry_;
      } else {
        let check = this.questionObservationInfo.find(q => q.ObPointId == this.selectedObservationPoint.ObservationPointId && q.ReadingNumber.toString() == "1");
        if (check) {
          console.log("check", check)
          check.Measurement = 0;
          check.UoM = this.UoM;
          check.obsImages = this.obImages;
          check.comment = this.selectedObservationPoint.comment;
          check.obsUnabletoComplete = this.selectedObservationPoint.obsUnabletoComplete;
          check.obsFlagID = this.obsFlagId;
          check.obsFlagColour = this.obsFlagColour;
        } else {
          console.log("!check", arry_)
          arracpy = this.questionObservationInfo;
          arracpy = arracpy.concat(arry_);
          this.questionObservationInfo = arracpy;
        }
      }
      this.fq.ObservationDetails = this.questionObservationInfo;
    }
  }


  UpdateObsWIP(event: any) {
    this.obsWIP = event.checked;
    this.selectedObservationPoint.obsWorkInProgress = event.checked;
    console.log("this.obsWIP______", this.obsWIP, this.selectedObservationPoint.obsWorkInProgress, event.checked)
    this.fq.Flag = true;
    this.obsDetails.map(x => {
      if (x.ObservationPointId == this.selectedObservationPoint.ObservationPointId) {
        x.obsWorkInProgress = this.obsWIP;
        this.selectedObservationPoint.obsWorkInProgress = this.obsWIP;
        this.SelectObPoint(x);
      }
    })
    var result = this.questionObservationInfo.reduce((unique, o) => {
      if (!unique.some(obj => obj.ObPointId === o.ObPointId && obj.ReadingNumber === o.ReadingNumber)) {
        unique.push(o);
      }
      return unique;
    }, []);
    console.log("result____", result);
    this.questionObservationInfo = result;
    console.log("this.questionObservationInfo__", this.questionObservationInfo)
    this.obsWIP = event.checked;
    if (event.checked == true) {
      //let commentaaddedFlag = this.flagTypes.find(x => x.ID == 2);
      // console.log("obsUnable___", commentaaddedFlag)

      //this.obsFlagId = commentaaddedFlag.ID;
      //this.obsFlagColour = commentaaddedFlag.Color;
      // console.log("obsUnable___", this.obsFlagId, this.obsFlagColour)

      // this.fq.ClearFlag=false;
      //this.fq.updateFlag=true;
    }
    this.selectedObservationPoint.obsWorkInProgress = this.obsWIP;
    if (this.selectedObservationPoint.numberOfReading > 0) {
      let arry_ = [];
      let obj = {
        ObPointId: this.selectedObservationPoint.ObservationPointId,
        ReadingNumber: 1,
        Measurement: 0,
        Percentage: 0,
        Uom: this.UoM,
        obsImages: this.obImages,
        comment: this.obsComment,
        obsWorkInProgress: this.selectedObservationPoint.obsWorkInProgress,
        obsFlagID: this.obsFlagId,
        obsFlagColour: this.obsFlagColour,
      }
      arry_.push(obj);
      let arracpy = [];
      if (this.questionObservationInfo == null || this.questionObservationInfo == undefined) {
        this.questionObservationInfo = arry_;
      } else {
        let check = this.questionObservationInfo.find(q => q.ObPointId == this.selectedObservationPoint.ObservationPointId && q.ReadingNumber.toString() == "1");
        if (check) {
          console.log("check", check)
          check.Measurement = 0;
          check.UoM = this.UoM;
          check.obsImages = this.obImages;
          check.comment = this.selectedObservationPoint.comment;
          check.obsWorkInProgress = this.selectedObservationPoint.obsWorkInProgress;
          check.obsFlagID = this.obsFlagId;
          check.obsFlagColour = this.obsFlagColour;
        } else {
          console.log("!check", arry_)
          arracpy = this.questionObservationInfo;
          arracpy = arracpy.concat(arry_);
          this.questionObservationInfo = arracpy;
        }
      }
      this.fq.ObservationDetails = this.questionObservationInfo;
    }
  }

  OpenEqDetails() {
    window.open('/dfi-implementdetails/' + this.form.EquipmentId, '_blank');
  }

  ChangeCackStatu(event: any) {
    this.crackStatus = event.target.value;
    console.log("Crack", event.target.value, this.InspectionSMU)
    let crackUpdate = new CrackStausUpdateVM();
    crackUpdate.smu = this.InspectionSMU;
    crackUpdate.obsId = this.selectedObservationPoint.ObservationPointId;
    crackUpdate.status = this.crackStatus == 1 ? false : true;
    crackUpdate.date = new Date(this.eventDate);
    crackUpdate.comment = "";
    crackUpdate.cost = 0;
    console.log("Crack", event.target.value, this.InspectionSMU, crackUpdate)
    this._inventoryService.CrackStatusUpdate(crackUpdate).subscribe(res => {
      if (res == true) {
        this.toastr.success("Sucessfully Updated the Crack Status")
        this.LoadFormUploadDetails();
      } else {
        this.toastr.success("Unable to Updated the Crack Status")
      }
    })
  }


  SelectObPoint(obPoint: ObservationPointVM) {
    this.crackStatus = obPoint.isCrackFixed == true ? 2 : 1;
    this.obsComment = "";
    this.obImages = null;
    this.obsFlagId = null;
    this.obsFlagComment = "";
    this.obsFlagColour = "";
    this.obsUnable = false;
    this.crackStatus = null;
    this.obsDetails.map((x, i) => {
      if (x.ObservationPointId == obPoint.ObservationPointId) {
        x.selected = true;
        this.currentIndex = i;
        //this.selectedObservationPoint.obsUnabletoComplete=obPoint.obsUnabletoComplete;
      } else {
        x.selected = false;
      }
    })

    this.measurement = null;
    this.eval = null;

    this.measurement = obPoint.measurement_
    console.log("obPoint.measurement_", obPoint.measurement_)

    console.log("Obs___11", obPoint, this.fq.ObservationDetails)

    if (this.fq.ObservationDetails != null) {
      this.questionObservationInfo = this.fq.ObservationDetails;
      this.questionObservationInfo.map(x => {
        if (obPoint.observationPointTypeId != 3 && obPoint.observationPointTypeId != 4) {

          if (x.ObPointId == obPoint.ObservationPointId && x.ReadingNumber.toString() == "1") {

            this.measurementinMM = x.Measurement
            var val
            val = (x.Measurement / 25.4).toFixed(1)
            this.measurementinInches = val

            console.log("Obs___11", obPoint, x)
            if (this.PrefUOM == 1) {
              this.measurement = this.measurementinMM
            }
            else {
              this.measurement = this.measurementinInches

            }

            this.ReadingNum = 1;
            this.obImages = x.obsImages;
            this.obsComment = x.comment;
            this.obsFlagId = x.obsFlagID;
            this.obsFlagComment = x.obsFlagComment;
            this.obsFlagColour = x.obsFlagColour;
            this.obsUnable = x.obsUnabletoComplete;
            this.obsWIP = x.obsWorkInProgress;
            this.crackStatus = obPoint.isCrackFixed == true ? 2 : 1;
          } else {
            this.ReadingNum = 1;
            this.crackStatus = obPoint.isCrackFixed == true ? 2 : 1;
            //this.obImages= x.obsImages;
          }
        } else {
          if (x.ObPointId == obPoint.ObservationPointId && x.ReadingNumber.toString() == "1") {
            this.eval = x.Measurement;
            this.ReadingNum = 1;
            this.obImages = x.obsImages;
            this.obsComment = x.comment;
            this.obsUnable = x.obsUnabletoComplete;
            this.obsWIP = x.obsWorkInProgress;

            this.obsFlagId = x.obsFlagID;
            this.obsFlagComment = x.obsFlagComment;
            this.obsFlagColour = x.obsFlagColour;
            this.crackStatus = obPoint.isCrackFixed == true ? 2 : 1;

          }
        }
      })
    }




    this.selectedObservationPoint = obPoint;
    let obArr = [];
    if (this.selectedObservationPoint.numberOfReading == 1) {
      let obj = {
        ObPointId: this.selectedObservationPoint.ObservationPointId,
        ReadingNumber: 1,
        Measurement: null,
        Percentage: 0,
        obsUnabletoComplete: this.selectedObservationPoint.obsUnabletoComplete,
        obsWorkInProgress: this.selectedObservationPoint.obsWorkInProgress,

        comment: "",
      }
      obArr.push(obj);
      this.observationpointMeasurements = obArr;
    } else {
      for (let index = 1; index <= this.selectedObservationPoint.numberOfReading; index++) {

        let obj = {
          ObPointId: this.selectedObservationPoint.ObservationPointId,
          ReadingNumber: index,
          Measurement: null,
          obsUnabletoComplete: this.selectedObservationPoint.obsUnabletoComplete,
          obsWorkInProgress: this.selectedObservationPoint.obsWorkInProgress,

          comment: this.selectedObservationPoint.comment,

        }
        obArr.push(obj);
      }
      this.observationpointMeasurements = obArr;
    }
  }

  selectSchImage(image: string, schematicId: number) {
    this.selectedObservationPoint = null;
    this.observationpointMeasurements = [];
    this.schematicImage = image;
    this.schematicImageId = schematicId;
    this.obsDetails = [];
    let arrayobs = [];
    if (this.fq.ModelAnswers != null && this.fq.ModelAnswers.length > 0) {
      this.fq.ModelAnswers.map(r => {
        r.Components.map(x => {
          if (x.ObservationPoint != null) {
            if (x.ObservationPoint.length > 0) {
              x.ObservationPoint.map(ob => {
                if (ob.schematic_auto == schematicId) {
                  arrayobs.push(ob);

                }
              })
            }
          }

        })
      })

      this.obsDetails = arrayobs;
      if (this.obsDetails.length > 0) {
        this.obsDetails[0].selected = true;
        this.SelectObPoint(this.obsDetails[0]);
      }
    }
  }

  setNextButon() {
    let index = this.formQuestions.findIndex(x => x.QuestionId == this.fq.QuestionId)
    let q = this.formQuestions[index + 1]
    if (q) {
      this.fq = q;
      this.isAnswerMandatory = this.fq.IsAnswerMandatory;
      console.log('this.fq Next__', this.fq);
      this.fqOld = JSON.parse(JSON.stringify(this.fq));
      console.log('this.fq NextOld__', this.fqOld);
      //check implemt type  link Question
      if (this.fq.QuestionTypeId == 6) {
        this.SetDefaultSchemanticImage();
      }
    } else {
      // SetQuestion(questionsList[index+1])
    }

    let checkNext = this.formQuestions[index + 2]
    console.log("checkNext___", checkNext)
    if (checkNext && checkNext != undefined) {
      this.showNextBtn = true;
    } else {
      this.showNextBtn = false;
    }

    this.showPrevBtn = true;
  }

  setPreviousButton() {
    this.fq.Flag = false;
    let index = this.formQuestions.findIndex(x => x.QuestionId == this.fq.QuestionId)
    let q = this.formQuestions[index - 1]
    if (q) {
      this.fq = q;
      this.isAnswerMandatory = this.fq.IsAnswerMandatory;
      console.log('this.fq Prev__', this.fq);
      this.fqOld = JSON.parse(JSON.stringify(this.fq));
      console.log('this.fq PrevOld__', this.fqOld);
      //check implemt type  link Question
      if (this.fq.QuestionTypeId == 6) {
        this.SetDefaultSchemanticImage();
      }
    }
    let checPrev = this.formQuestions[index - 2]
    if (checPrev) {
      this.showPrevBtn = true;
    } else {
      this.showPrevBtn = false;
    }
    this.showNextBtn = true;
  }

  UoM: number = 1;
  measurement: number;
  ReadingNum: number = 1;

  obsFlagId: number;
  obsFlagComment: string;
  obsFlagColour: string;;
  ChangeReadingNum(event: any) {
    this.fq.Flag = true;
    console.log("ReadingNum_", event)
    let val = event.target.value;
    this.ReadingNum = val;

    this.measurement = null;


    this.questionObservationInfo.map(x => {
      if (this.selectedObservationPoint.observationPointTypeId != 3 && this.selectedObservationPoint.observationPointTypeId != 4) {
        if (x.ObPointId == this.selectedObservationPoint.ObservationPointId && x.ReadingNumber.toString() == this.ReadingNum.toString()) {
          this.measurement = x.Measurement;

          //this.ReadingNum=1;
        }
      }
    })

  }

  eval: number = 1;
  SelectEvaluation(event: any) {
    console.log("selected Eval", this.eval)

    this.fq.Flag = true;
    this.eval = event.target.value;
    console.log("selected Eval11111", this.eval)
    // if (this.selectedObservationPoint.numberOfReading == 1) {
    let arry_ = [];
    let obj = {
      ObPointId: this.selectedObservationPoint.ObservationPointId,
      ReadingNumber: 1,
      Measurement: this.eval,
      Percentage: 0,
      UoM: this.UoM,
      obsFlagID: null,
    }
    arry_.push(obj);
    let arracpy = [];


    if (this.questionObservationInfo == null || this.questionObservationInfo == undefined) {
      this.questionObservationInfo = arry_;
    } else {

      let check = this.questionObservationInfo.find(q => q.ObPointId == this.selectedObservationPoint.ObservationPointId && q.ReadingNumber == 1);

      if (check) {
        console.log("check____", check)
        check.Measurement = this.eval;
      } else {
        arracpy = this.questionObservationInfo;
        arracpy = arracpy.concat(arry_);
        this.questionObservationInfo = arracpy;
      }
    }


    var result = this.questionObservationInfo.reduce((unique, o) => {
      if (!unique.some(obj => obj.ObPointId === o.ObPointId && obj.ReadingNumber === o.ReadingNumber)) {
        unique.push(o);
      }
      return unique;
    }, []);

    console.log("result____", result);
    this.questionObservationInfo = result;

    this.fq.ObservationDetails = this.questionObservationInfo;
    console.log("this.questionObservationInfo__1111", this.questionObservationInfo)
    //} 

  }
  isChange: boolean = false;
  ChangeUnitType(event: any) {
    console.log("UOM___", event, event.target.value)
    this.UoM = event.target.value;
    this.selectedUOM = event.target.value;



    if (this.UoM == 1) {
      this.measurement = this.measurementinMM
    }
    if (this.UoM == 2) {
      this.measurement = this.measurementinInches
    }

  }

  obImages: string[];
  UpdateMeasurement(event: any) {


    let measurement_ = event.target.value;
    console.log("Measurement__", measurement_)
    if (measurement_.length > 0) {
      this.fq.Flag = true;


      if (this.selectedObservationPoint.observationPointTypeId != 3 && this.selectedObservationPoint.observationPointTypeId != 4) {
        if (this.selectedObservationPoint.numberOfReading == 1) {
          let arry_ = [];
          let obj = {
            ObPointId: this.selectedObservationPoint.ObservationPointId,
            ReadingNumber: 1,
            Measurement: measurement_,
            Percentage: 0,
            Uom: this.UoM,
            obsImages: this.obImages,
            comment: this.obsComment,
          }
          arry_.push(obj);
          let arracpy = [];

          console.log("this.questionObservationInfo__", this.questionObservationInfo)
          if (this.questionObservationInfo == null || this.questionObservationInfo == undefined) {
            this.questionObservationInfo = arry_;
          } else {

            let check = this.questionObservationInfo.find(q => q.ObPointId == this.selectedObservationPoint.ObservationPointId && q.ReadingNumber.toString() == "1");

            if (check) {
              check.Measurement = measurement_;
              check.UoM = this.UoM;
              check.obsImages = this.obImages;
              check.comment = this.obsComment;
            } else {
              arracpy = this.questionObservationInfo;
              arracpy = arracpy.concat(arry_);
              this.questionObservationInfo = arracpy;
            }
          }
          this.fq.ObservationDetails = this.questionObservationInfo;
        } else {
          let arry_ = [];
          let obj = {
            ObPointId: this.selectedObservationPoint.ObservationPointId,
            ReadingNumber: this.ReadingNum,
            Measurement: measurement_,
            Uom: this.UoM,
            obsImages: this.obImages,
            comment: this.obsComment,
          }
          arry_.push(obj);
          let arracpy = [];
          if (this.questionObservationInfo == null) {
            this.questionObservationInfo = arry_;
          } else {

            let check = this.questionObservationInfo.find(q => q.ObPointId == this.selectedObservationPoint.ObservationPointId && q.ReadingNumber.toString() == this.ReadingNum.toString());

            if (check) {
              check.Measurement = measurement_;
              check.UoM = this.UoM;
              check.obsImages = this.obImages;
              check.comment = this.obsComment;
            } else {
              arracpy = this.questionObservationInfo;
              arracpy = arracpy.concat(arry_);
              this.questionObservationInfo = arracpy;
            }


          }
          this.fq.ObservationDetails = this.questionObservationInfo;
        }
      }
    }
    console.log("Question___", this.fq)
  }
  // getPosition(posX: string, posY: string) {
  //   var iPX = (parseFloat(posX) / 640.0) * 340;
  //   var iPY = (parseFloat(posY) / 520.0) * 270;
  //   return this._sanitizer.bypassSecurityTrustStyle('Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;' + 'Position: absolute;');
  // }

  displayLedgend: boolean = false;
  mouseOverAction() {
    this.displayLedgend = true;
  }
  mouseleaverAction() {
    this.displayLedgend = false;
  }

  closeLedgend() {
    this.displayLedgend = false;
  }
  getPosition(posX: string, posY: string) {
    var iPX = (parseFloat(posX));
    var iPY = (parseFloat(posY));
    return this._sanitizer.bypassSecurityTrustStyle('Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;' + 'Position: absolute;z-index:1');
  }

  getLine(posX: string, posY: string, EndposX: string, EndposY: string, isCrackFixed: boolean) {
    // bottom right
    var x1 = (parseFloat(posX));
    var y1 = (parseFloat(posY));
    // top right
    var x2 = (parseFloat(EndposX));
    var y2 = (parseFloat(EndposY));
    // distance
    var length = Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)));
    // center
    var cx = (((x1 + x2) / 2) - (length / 2)) + 7;
    var cy = ((y1 + y2) / 2) - (4 / 2);
    // angle
    var angle = Math.atan2((y1 - y2), (x1 - x2)) * (180 / Math.PI);
    // make hr
    var colour = isCrackFixed == false ? "#EC0A0A" : "#4472C4";
    return this._sanitizer.bypassSecurityTrustStyle('padding:0px; margin:0px; height:' + 4 +
      'px; background-color:' + colour + '; line-height:1px; position:absolute; left:' + cx +
      'px; top:' + cy + 'px; width:' + length + 'px; -moz-transform:rotate(' + angle + 'deg); -webkit-transform:rotate(' + angle + 'deg); -o-transform:rotate(' + angle + 'deg); -ms-transform:rotate(' + angle + 'deg); transform:rotate(' + angle + 'deg);');

  }
  openSchematicWindow(SchematicImage: string, selectedQ: DigitalFormQuestionsVM) {
    //updateQuestion
    if (this.fq.Flag == true) {
      this.UpdateQuestion();
    }
    console.log("Open obs", selectedQ, this.obsDetails)


    const addSectionDialog = this._editPhotoDialog.open(AddCrackObsPointDialogComponent, {

      data: {
        obsDetails: this.obsDetails,
        schematic: SchematicImage,
        componentList: this.componentList,
        schematicId: this.schematicImageId,
        isDFI: true,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details > 0) {
        //reload Question
        if (this.formId > 0 && this.uploadId > 0 && this.sectionId > 0) {
          this.selectedQId == this.fq.QuestionId;
          this.LoadFormUploadDetails();
        }
      } else {

      }
    });

  }

  FilterObs() {
    console.log("this.FixedCracks", this.FixedCracks, this.NotFixedCracks)
    this.obsDetails = this.CopyobsDetails;

    if (this.FixedCracks == true && this.NotFixedCracks == true) {
      this.obsDetails = this.CopyobsDetails;

    } else if (this.FixedCracks == false && this.NotFixedCracks == false) {
      this.obsDetails = this.obsDetails.filter(z => z.observationPointTypeId != 2)
    }
    else if (this.FixedCracks == true) {

      this.obsDetails = this.obsDetails.filter(z => z.isCrackFixed == true || z.observationPointTypeId != 2)
    } else {
      this.obsDetails = this.obsDetails.filter(z => z.isCrackFixed == false || z.observationPointTypeId != 2)
    }
  }


  getUnitOFMeasurement() {
    this._pref.getGeneralTabPreferences().subscribe(pref => {
      if (pref.UnitOfMeasurementName == "mm") {
        this.PrefUOM = 1
        this.UOMLabel = "mm"
      }
      if (pref.UnitOfMeasurementName == "inch") {
        this.PrefUOM = 2
        this.UOMLabel = "inch"

      }

      console.log("pref.UnitOfMeasurementName", pref.UnitOfMeasurementName)
      console.log("uom", this.PrefUOM)
      this.selectedUOM = this.PrefUOM
    })

  }
}
